// extracted by mini-css-extract-plugin
export default {"headerBrand":"headerBrand___ppNqC","headerBrand_image":"headerBrand_image___znb2h","headerBrand_label":"headerBrand_label___wStJV"};